import type { BadgeTone } from '@buyerflo/ui/utils/color'

/** Format integer cents as AUD. */
export const fmtAud = (cents: number) =>
    new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((cents ?? 0) / 100)

export const fmtDate = (ms?: number) => (ms ? new Date(ms).toLocaleDateString('en-AU') : '—')

export const affiliateStatusTone: Record<string, BadgeTone> = {
    active: 'ok',
    paused: 'warn',
    disabled: 'danger',
    archived: 'neutral',
}

export const referralStatusTone: Record<string, BadgeTone> = {
    trialing: 'info',
    active: 'ok',
    past_due: 'warn',
    cancelled: 'danger',
}

export const connectStatusTone: Record<string, BadgeTone> = {
    complete: 'ok',
    pending: 'warn',
    not_started: 'neutral',
}

export const connectStatusLabel: Record<string, string> = {
    complete: 'Payouts ready',
    pending: 'Setup pending',
    not_started: 'Not set up',
}
